import { render } from "./DialogDelete.vue?vue&type=template&id=a72a347e&ts=true"
import script from "./DialogDelete.vue?vue&type=script&lang=ts"
export * from "./DialogDelete.vue?vue&type=script&lang=ts"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__